import React from "react";

import Button from "../atoms/button";

class ButtonApply extends React.Component {
  render() {
    return (
      <Button
        className="btn-fixed"
        type="apply"
        to="contact"
        onClick={e => {
          this.props.getTarget().scrollIntoView({ behavior: "smooth" });
          e.preventDefault();
          return false;
        }}
      >
        {this.props.children}
      </Button>
    );
  }
}

export default ButtonApply;
